export class DropdownDisplayItem {
  translationId: string;
  value: string;

  constructor(translationId: string, value: string) {
    this.translationId = translationId;
    this.value = value;
  }
}
